import catalog from './voicePlanCatalog.json';

export const VOICE_PLANS = catalog.plans.map((plan) => ({ ...plan, price: plan.monthlyCents / 100 }));
export const EXTRA_MINUTE_PRICE = `${(catalog.extraMinuteCents / 100).toFixed(2).replace('.', ',')} €`;
export const VOICE_PLAN_SUMMARY = VOICE_PLANS.map((plan) =>
  `${plan.name}: ${plan.price} €/mese, ${plan.minutes.toLocaleString('it-IT')} minuti e ${plan.sms} segmenti SMS`
).join('; ');

export const PLAN_CATALOG = {
  free: {
    id: 'free',
    name: 'RistoDaily Free',
    price: '0 €',
    priceSuffix: 'per sempre',
    capabilities: { calls: false, sms: false, voice: false },
    features: [
      'Agenda prenotazioni completa',
      'Sale, tavoli e combinazioni automatiche',
      'Turni, chiusure e disponibilità reali',
      'Link pubblico per Google, social e sito',
      'Modifica e cancellazione autonoma',
      'Conferme via email',
      'Provenienza e valore prenotato',
    ],
  },
  ...Object.fromEntries(VOICE_PLANS.map((plan) => [plan.id, {
    ...plan,
    price: `${plan.price} €`,
    priceSuffix: 'al mese',
    capabilities: { calls: true, sms: true, voice: true },
    features: [
      'Tutto il calendario gratuito',
      'Assistente vocale AI in italiano',
      'Risponde a domande, orari e disponibilità',
      'Prenota direttamente durante la chiamata',
      `${plan.minutes.toLocaleString('it-IT')} minuti inclusi al mese`,
      `${plan.sms} segmenti SMS inclusi al mese`,
      `Minuti extra: ${EXTRA_MINUTE_PRICE}/min`,
      'Modifica e annullamento dal link SMS',
    ],
  }])),
};

// Operational codes remain backward compatible with DB entitlements and
// existing subscriptions. In particular, legacy "pro" is NOT a €379 contract.
export function normalizePlan(plan) {
  return ['free', 'base', 'pro'].includes(plan) ? plan : 'free';
}

export function planHas(plan, capability) {
  const operational = normalizePlan(plan);
  return capability === 'voice' ? operational === 'pro'
    : ['calls', 'sms'].includes(capability) && operational !== 'free';
}

export function assignedPlan(settings = {}) {
  if (settings.plan === 'pro' && VOICE_PLANS.some((plan) => plan.id === settings.voice_plan)) {
    return PLAN_CATALOG[settings.voice_plan];
  }
  if (normalizePlan(settings.plan) === 'free') return PLAN_CATALOG.free;
  return {
    id: `legacy_${settings.plan}`,
    name: settings.plan === 'base' ? 'Recover SMS · configurazione precedente' : 'Voice AI · piano da assegnare',
    features: ['Configurazione esistente conservata', 'Nessuna nuova tariffa assegnata automaticamente'],
  };
}

export function restaurantPlan(row) {
  return assignedPlan({ plan: row.operational_plan, voice_plan: row.voice_plan });
}

